export function regionIdReducer(state: null = null): number | null {
  return state;
}
